import React, { useState } from 'react'
import { validateItemByType } from './utils';

const useCustomTemplateItemsValidation = () => {
    ///////////////// Custom Import Form //////////////////////
    let valItemsModal = {}
    let ValidationItemsModal = {
    }
    const validateAllItems = (items) => {
        const validationResult = {};

        (items || []).forEach(item => {
            const key = item.ItemID;
            validationResult[key] = validateItemByType(item);
        });

        return validationResult;
    };

    // const ValidationItems = async () => {
    //     const items = customTemplateData?.[0]?.Data?.[0]?.items;
    //     const ValidationItemsModal = validateAllItems(items);

    //     await setValidationItemsModal(ValidationItemsModal)
    //     valItemsModal = ValidationItemsModal
    // }

    const [validationItemsModal, setValidationItemsModal] = useState(ValidationItemsModal);

    const handleSetDefaultItemsForValidation = (Data) => {
        // console.log("handleSetDefaultItemsForValidationData hook",Data)
        setValidationItemsModal(() => {
            return (Data || []).reduce((acc, item) => {
                acc[item.ItemID] = "";
                return acc;
            }, {});
        }
        );
    }
    return { validationItemsModal, handleSetDefaultItemsForValidation }
}

export default useCustomTemplateItemsValidation